import React, { useCallback, useTransition } from "react";
import List from "@commonComponents/List";
import AuthorizationForm from "@EUForms/authorizationForm";
import InputField from "@commonComponents/formComponents/CustomInputField";
import { Grid } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import useValidationAES from "../../hooks/useValidationAES";
import { useTranslation } from "@hooks/useTranslation";



const AuthorizationDetail = ({dataSource, onSelect, isItemsTab=false,validationErrors,...rest}) => {
  const { updateMerchActorsRoleTypeError } = useValidationAES()
  const dispatch = useDispatch()
  const translate = useTranslation()
  const renderAtLast=useCallback(({dataSource,onChangeHandler,onBlurHandler})=>{

    return (
      <Grid.Column>
      <InputField
          isLabel={false}
          id={`owner${dataSource.id}`}
          name="owner"
          type="text"
          label="OWNER"
          value={dataSource.owner}
          clearInput={false}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
          
        />
        </Grid.Column>
    )

  },[])
  const renderItem=useCallback((item)=> {
    const onSelectHandler = (id, tableName, params, name) => {
      onSelect(id, tableName, params)
      validationErrors && validationErrors()
      if (isItemsTab && (name === 'type')) { // working on...
        dispatch(updateMerchActorsRoleTypeError({
          dataSource,
          key: name,
          value: params[name],
          tableName,
          merchandiseId: rest?.merchandiseId,
          invoiceIndex: rest?.invoiceIndex,
          itemIndex: rest?.itemIndex,
          translate
        }))
      }
    }
    const onDeleteHandler = async (id, tableName, params) => {
      await deleteData(id, tableName, params)
      if (isItemsTab)dispatch(updateMerchActorsRoleTypeError({
        dataSource,
        key: 'type',
        value: '',
        tableName,
        merchandiseId: rest?.merchandiseId,
        invoiceIndex: rest?.invoiceIndex,
        itemIndex: rest?.itemIndex,
        translate
      }))
    }
  return <AuthorizationForm 
  dataSource={item} 
  key={item.id} 
  renderAtLast={renderAtLast}
  onSelect={onSelectHandler}
  deleteData={onDeleteHandler}
  isItemsTab={isItemsTab}
  {...rest} />
  },[rest,renderAtLast])

  
  return <List className="responsiveGridCss"  dataSource={dataSource}renderItem={renderItem}/>
      
}

export default React.memo(AuthorizationDetail)
